import React from 'react';
import { Segment, Button } from 'semantic-ui-react';
import MembershipTable from './MembershipTable';

const ManageMemberships = () => {
	let tableRef = React.useRef(null);
	return (
		<div className="animated fadetwoIn padded-top dnp-page">
			<Segment.Group stacked>
				<Segment color='green' className="tableHeaderContainer">
					<div />
					<h2>Memberships</h2>
					<Button
						onClick={() => {
							if(tableRef && tableRef.current) {
								tableRef.current.refresh();
							}
						}}
						content={<i className="fa fa-refresh fa-lg filterIcon" aria-hidden="true" />}
					/>
				</Segment>
				<Segment placeholder>
					<MembershipTable
						ref={tableRef}
						path="/admin/memberships"
					/>
				</Segment>
			</Segment.Group>
		</div>
	);
};

export default ManageMemberships;